// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3yyfH","rootCenter":"LoadMoreObserver_rootCenter__3JHWC","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1H7up"};